import Tables from 'src/class/Tables';
import i18n from '../../../../i18n'

const configTable = () => {
  const Table = { ...Tables.Table };
  Table.tableColumns = [
    {
      prop: 'name',
      label: i18n.t('common_words.name'),
      minWidth: 150,
    },
    {
      prop: 'scientific_name',
      label: i18n.t('diseases.scientific_name'),
      minWidth: 160,
    },
    {
      prop: 'observation',
      label: i18n.t('common_words.observation'),
      minWidth: 230,
    },
    {
      prop: 'type',
      label: i18n.t('common_words.type'),
      minWidth: 150,
    },
    {
      prop: 'type_p_e_name',
      label: i18n.t('diseases.plague_or_disease_questionmark'),
      minWidth: 190,
    },
  ];

  return { Table };
};

export default configTable;
